export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
                <i className="ri-smartphone-line text-primary-500 text-sm"></i>
                <span className="text-xs font-medium text-primary-700">移动端体验</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                随时随地，<span className="text-primary-500">畅快吃瓜</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
                911爆料网全面适配移动端，无论你是在通勤路上、午休时间还是睡前消遣，打开手机浏览器即可访问911吃瓜黑料入口，随时随地享受最新最全的吃瓜体验。无需下载APP，轻量级访问，省流量更便捷。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 bg-secondary-100 rounded-lg px-4 py-2.5">
                  <i className="ri-qr-code-line text-lg text-secondary-600"></i>
                  <span className="text-sm font-medium text-secondary-700">扫码访问</span>
                </div>
                <div className="flex items-center gap-2 bg-secondary-100 rounded-lg px-4 py-2.5">
                  <i className="ri-bookmark-line text-lg text-secondary-600"></i>
                  <span className="text-sm font-medium text-secondary-700">添加到桌面</span>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center">
              <div className="relative w-64 h-[460px] bg-background-950 rounded-[2.5rem] border-4 border-background-800 overflow-hidden">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-6 bg-background-950 rounded-b-xl z-10"></div>
                <div className="h-full w-full bg-gradient-to-b from-primary-500/10 to-background-950 flex flex-col items-center justify-center p-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-xl mb-3">
                    <i className="ri-fire-fill text-background-50 text-xl"></i>
                  </div>
                  <div className="text-background-50 text-sm font-bold mb-1">911爆料网</div>
                  <div className="text-foreground-400 text-xs mb-6">随时随地·畅快吃瓜</div>

                  <div className="w-full space-y-2">
                    {['最新爆料 🔥', '热门榜单 📈', '视频吃瓜 🎬', '专题合集 📁'].map((item) => (
                      <div
                        key={item}
                        className="bg-background-800 rounded-lg px-3 py-2.5 text-xs text-background-50/80 text-center"
                      >
                        {item}
                      </div>
                    ))}
                  </div>

                  <div className="mt-auto w-full bg-primary-500 rounded-lg py-2.5 text-center text-xs font-bold text-background-50">
                    立即吃瓜
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}